<template>
  <div class="DataTable">
    <!-- <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
    >
      Izaberite jedan od kataloga iz menija
    </div> -->
    <div>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('additive')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/aditivi.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('additive_group')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/grupe_aditiva.png`" alt="icon" />
        </button>
      </span>

      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('currency')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/valute.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('grape_variety')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/sorte grozdja.png`" alt="icon" />
        </button>
      </span>
    </div>

    <div>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('unit_of_measure')"
          slot="activator"
        >
          <img :src="`../assets/IkoneKatalozi/jedinice_mere.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('unit_of_measure_group')"
          slot="activator"
        >
          <img :src="`../assets/IkoneKatalozi/grupe_jm.png`" alt="icon" />
        </button>
      </span>

      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('vine_yard')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/vinogradi.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('vine_yard_block')"
          slot="activator"
        >
          <img
            :src="`../assets/IkoneKatalozi/parcele_u_vinogradu.png`"
            alt="icon"
          />
        </button>
      </span>
    </div>
    <div>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('vine_yard_table')"
          slot="activator"
        >
          <img
            :src="`../assets/IkoneKatalozi/table_u_vinogradu.png`"
            alt="icon"
          />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('vineyard_grape')" slot="activator">
          <img
            :src="`../assets/IkoneKatalozi/grozdje_u_vinogradu.png`"
            alt="icon"
          />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('parameter')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/parametri.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('ware_house')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/magacini.png`" alt="icon" />
        </button>
      </span>
    </div>
    <div>
      
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('warehause_type')" slot="activator">
          <img
            :src="`../assets/IkoneKatalozi/tipovi_magacina.png`"
            alt="icon"
          />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('vineyard_operation')"
          slot="activator"
        >
          <img
            :src="`../assets/IkoneKatalozi/operacije_u_vinogradu.png`"
            alt="icon"
          />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('employee')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/zaposleni.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('externalWorkForce')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/eksterni_radnici.png`" alt="icon" />
        </button>
      </span>
    </div>
    <div>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('company')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/kompanije.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('mehanization')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/mehanizacija.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button
          @click="routerLinkToDetails('vineyard_operation')"
          slot="activator"
        >
          <img
            :src="`../assets/IkoneKatalozi/operacije_u_vinogradu.png`"
            alt="icon"
          />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('winery')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/maticni_podaci.png`" alt="icon" />
        </button>
      </span>
    </div>
    <div>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('phenophase')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/feno_faze.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('pruningtype')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/tip_rezidbe.png`" alt="icon" />
        </button>
      </span>
      <span style="padding-left: 40px">
        <button @click="routerLinkToDetails('breedingtype')" slot="activator">
          <img :src="`../assets/IkoneKatalozi/uzgojni_oblik.png`" alt="icon" />
        </button>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "singleTank",
  methods: {
    routerLinkToDetails(page) {
      this.$router.push({ name: page });
    },
  },
};
</script>

<style lang="scss" scoped>
.unitOfMeasureItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
